import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeProduct: {},
    activeArea: {},
    currentUser: {},
  },
  getters: {
    activeProduct: (state) => state.activeProduct,
    activeArea: (state) => state.activeArea,
    currentUser: (state) => state.currentUser,
    isAdmin: (state) => state.currentUser
      && state.currentUser.attributes
      && state.currentUser.attributes['custom:role'] === 'admin',
  },
  mutations: {
    setActiveProduct: (state, payload) => {
      state.activeProduct = payload;
    },
    setActiveArea: (state, payload) => {
      state.activeArea = payload;
    },
    setCurrentUser: (state, payload) => {
      state.currentUser = { ...payload };
    },
  },
  actions: {},
  modules: {},
});
